import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, Link } from 'react-router-dom';
import Swal from "sweetalert2";
import { recoveryPassword } from '../../reducers/actions/auth';

const PasswordRecovery = () => {
  const {
    register,
    formState: { errors },
  } = useForm();
  
  const navigate = useNavigate()
  const { token } = useParams(); // Get the token from the URL params
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('')
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      Swal.fire({
        title: "Advertencia",
        text: "Quiere confirmar esta acción?",
        icon: "info",
        showDenyButton: true,
        denyButtonText: "No",
        confirmButtonText: "Si",
        confirmButtonColor: "#3085d6",
      }).then(response => {
        if (response.isConfirmed) {
          dispatch(recoveryPassword(email))
            .then(() => {
              Swal.fire({
                icon: 'success',
                title: 'Exitoso!',
                text: 'Operación realizada correctamente.',
              }).then(r=>{
                navigate("/login");
              })
            })
            .catch(() => {
              setLoading(false);
            });
        }
        if (response.isDenied) {
          Swal.fire({
            title: "Cancelado",
            text: "Cancelaste el registro",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#3085d6",
          })
        }
      });
    } catch (error) {
      setMessage(error.response.data.message);
    }
  };

  const onChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };

  return (
    <div className="Auth-form-container">
      <form onSubmit={handleSubmit} className="Auth-form">
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Restaurar contraseña</h3>
          <div className="text-center">
            {" Ya estás registrado? "}
            <Link to={"/"}>Inicia sesión</Link>
          </div>
          <div className="form-group mt-3">
            <label>Por favor ingrese su email</label>
            <input
              name="email"
              type="email"
              className="form-control mt-1"
              placeholder="usuario@gmail.com"
              onChange={onChangeEmail}
            />
            <div className="form-group mt-3">
              <p>A este email se le enviará un enlace para reestablecer su contraeña</p>
            </div>
            <div className="d-grid gap-2 mt-3">
              <button className="btn btn-success">Reestablecer contraseña</button>
            </div>
            {errors.email?.message && (
              <span className="danger">Ingresa un email valido</span>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default PasswordRecovery;